import { Section } from '../layout/Section';
import { SectionHeader } from '../layout/SectionHeader';
import { Card } from '../ui/Card';
import { Picture } from '../ui/Picture';
import { Button } from '../ui/Button';
import { RevealGroup, RevealItem } from '../ui/Reveal';
import { whyNimblepark } from '../../data/landing';
import styles from './WhyNimblepark.module.css';

export function WhyNimblepark() {
  return (
    <Section id="why">
      <SectionHeader
        eyebrow={whyNimblepark.eyebrow}
        title={whyNimblepark.title}
        subtitle={whyNimblepark.subtitle}
        align="start"
      />

      <RevealGroup className={styles.grid} as="ul">
        {whyNimblepark.items.map((item) => (
          <RevealItem key={item.title} as="li" style={{ display: 'flex' }}>
            <Card elevation="raised" hoverable className={styles.card}>
              <Picture
                name={item.image}
                alt=""
                fit="contain"
                ratio="220 / 150"
                sizes="(max-width: 767px) 60vw, 220px"
                className={styles.art}
              />
              <h3 className={`${styles.title} u-h3`}>{item.title}</h3>
              <span className={styles.rule} aria-hidden="true" />
            </Card>
          </RevealItem>
        ))}
      </RevealGroup>

      <div className={styles.cta}>
        <Button to={whyNimblepark.cta.to} icon="arrow-right-circle">
          {whyNimblepark.cta.label}
        </Button>
      </div>
    </Section>
  );
}
